var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCabina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#707070;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M443,281.7H85.9V143.5c0-3-2.5-5.5-5.5-5.5H53c-3,0-5.5,2.5-5.5,5.5v219c0,3,2.5,5.5,5.5,5.5h27.3 c3.1,0,5.5-2.5,5.6-5.5v-35.6h324.2v35.6c0,3,2.5,5.5,5.5,5.5H443c3.1,0,5.5-2.5,5.5-5.5v-41.1v-34.2 C448.5,284.2,446,281.7,443,281.7z M74.8,357H58.4V149h16.4v138.2v34.2V357z M85.9,292.7h351.7v23.2h-22c-0.3,0-0.7,0-1,0.1H85.9 V292.7z M437.5,357h-16.4v-30.1h16.4V357z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.6,228.1c3,0,5.5-2.5,5.5-5.5v-10.3c0-8.3,6.8-15.1,15.1-15.1h75c8.3,0,15.1,6.8,15.1,15.1v10.3 c0,3,2.5,5.5,5.5,5.5s5.5-2.5,5.3-5.5v-10.3c0-14.3-11.7-26-26-26h-75c-14.3,0-26,11.7-26,26v10.3 C102.1,225.6,104.6,228.1,107.6,228.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M424.5,289.7H102.9c-14.3,0-26-11.7-26-26v-20.5c0-14.3,11.7-26,26-26h321.6c14.3,0,26,11.7,26,26v20.5 C450.5,278,438.9,289.7,424.5,289.7z M102.9,228.1c-8.3,0-15.1,6.8-15.1,15.1v20.5c0,8.3,6.8,15.1,15.1,15.1h321.6 c8.3,0,15.1-6.8,15.1-15.1v-20.5c0-8.3-6.8-15.1-15.1-15.1H102.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabina);
export default __webpack_public_path__ + "static/media/cabina.096a1253f98289ef891d50db6925e664.svg";
export { ForwardRef as ReactComponent };